import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import firebase from 'firebase/app'
require('firebase/auth')
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { store } from '../store.js';
import VueClipboard from 'vue-clipboard2';
Vue.use(require('vue-moment'));
Vue.use(Router);
Vue.use(VueClipboard)
const router = new Router({
    base: '/',
    mode: 'hash',
    linkActiveClass: 'active',
    routes: paths
});
// router gards
// router.beforeEach((to, from, next) => {
//     console.log("beforeEach",store.state.adminUser.checkLogin())
//     store.commit("hasPageHelp", false);
//     store.commit("page_name", to.name);
//     NProgress.start();

//     next()
// });
// router gards
router.beforeEach((to, from, next) => {
    store.commit("hasPageHelp", false);
    store.commit("page_name", to.name);
    NProgress.start();
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const currentUser = firebase.auth().currentUser
    if ((to.path == "/login" || to.path == "/") && currentUser) {
        next("/dashboard")
        return
    }
    if (requiresAuth && !currentUser) {
        //      next('/login')
    } else if (requiresAuth && currentUser) {
        next()
    } else {
        next()
    }
});
router.afterEach((to, from) => {
    // ...
    NProgress.done();
});

export default router;